module.exports = __webpack_public_path__ + "static/media/clearBookmark.4d1a1276.png";